// Private browsing / blocked storage must not prevent using the application.
export const readStorage = (key) => {
  try { return window.localStorage.getItem(key); } catch { return null; }
};

export const writeStorage = (key, value) => {
  try { window.localStorage.setItem(key, value); } catch { /* Storage is optional. */ }
};
